import React from 'react';
import styled from 'styled-components';
import ifEmoji from 'if-emoji';
const cookie = '🍪';
const CookieWrapper = styled.span `
    padding-right: 4px;
    font-size: 14px;
    vertical-align: text-bottom;
`;
export const CookieEmoji = () => {
    if (ifEmoji(cookie)) {
        return React.createElement(CookieWrapper, null, cookie);
    }
    return null;
};
